import { DetailSkeleton } from 'components/skeletons';
import { Box, Typography } from "@mui/material";
import { useGetTempWorker } from "core/temp_workers/hooks";
import { toast } from "react-toastify";
import { EditForm } from "./form";
import { useCallback } from "react";

interface CandidateEditFormProps {
  tempWorkerId: number;
  modalMode?: boolean;
}

export const CandidateEditForm = ({ tempWorkerId, modalMode }: CandidateEditFormProps) => {
  const { data: tempWorker, isLoading } = useGetTempWorker(tempWorkerId, {
    onError: (err) => toast.error("Une erreur est survenue"),
  });

  const renderLoadingError = useCallback(() => {
    return isLoading ? (
      <DetailSkeleton rows={8} />
    ) : (
      <Typography>Une erreur est survenue</Typography>
    );
  }, [isLoading]);

  return (
    <Box sx={{ width: '100%' }}>
      {tempWorker ? <EditForm tempWorker={tempWorker} modalMode={modalMode} /> : renderLoadingError()}
    </Box>
  );
};
